import { ApiError } from './ApiError';

export class ConflictError extends ApiError {
  constructor(body: any) {
    super(409, body);

    Object.setPrototypeOf(this, ConflictError.prototype);
  }
}
